var _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _circle2, _circle3, _path3, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _rect, _g20, _g21, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotRegistered = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 318,
  height: 318,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 159,
  r: 159,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7FC",
  d: "M84.887 258c-19.112 0-28.212 3.441-19.663 7.647 8.55 4.206 37.707 4.206 45.455 4.206s32.025-1.912 47.004-2.294c14.98-.383 22.211 3.441 44.939 3.441 22.727 0 22.211-3.441 30.475-5.353s28.41.382 27.893-3.441c-.413-3.059-8.092-4.079-11.88-4.206z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9DBE9",
  d: "M188.243 109.106h5.182v25.273h-5.182z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M178.58 198.351s-3.269 31.028 0 50.027"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 72.075,
  height: 48.674,
  x: 154.137,
  y: 75,
  fill: "#D9DBE9",
  rx: 24.337
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M181.422 148.896c-9.064 0-5.679 37.075-33.745 23.689"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__e)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 142.821,
  cy: 170.821,
  r: 6.821,
  fill: "#D9DBE9"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__f)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 62.714,
  height: 83.307,
  x: 159.073,
  y: 130.072,
  fill: "#D9DBE9",
  rx: 31.357
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M200.749 206.877s4.684 31.597 12.992 42.365"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#223",
  d: "M158.685 103.687a9.36 9.36 0 0 1 9.36-9.36h20.593a9.36 9.36 0 0 1 9.36 9.36 9.36 9.36 0 0 1-9.36 9.36h-20.593a9.36 9.36 0 0 1-9.36-9.36"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 168.045,
  cy: 103.687,
  r: 4.68,
  fill: "#E9EBF5"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 188.638,
  cy: 103.687,
  r: 4.68,
  fill: "#E9EBF5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#594D6B",
  fillRule: "evenodd",
  d: "M130.175 139.049a1 1 0 0 0-.207 1.399l.139.187-.796.591-.139-.187a1 1 0 0 0-1.399-.207l-1.958 1.453a2 2 0 0 0-.414 2.798l2.882 3.885a2 2 0 0 0 2.798.414l1.958-1.452a1 1 0 0 0 .338-1.161l.921-.683a4 4 0 0 0 4.925.123l.389-.289 8.573 11.048L163.4 178.22a4.493 4.493 0 1 0 6.829-5.792l-16.901-16.901c-1.4-1.4-2.67-2.924-3.795-4.554l-5.737-8.31a8 8 0 0 0 2.101-6.643 8.9 8.9 0 0 1 .775-5.109l3.034-6.353z",
  clipRule: "evenodd"
})), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#E8EAF5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M200.749 147.191c-18.759 27.285-28.34 15.463-41.414 15.463"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__i)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 155.477,
  cy: 161.909,
  fill: "#D9DBE9",
  rx: 6.477,
  ry: 6.909
}))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9DBE9",
  d: "M156.411 257.126a8.186 8.186 0 0 1 8.186-8.185h14.324a8.186 8.186 0 0 1 8.186 8.185 2.047 2.047 0 0 1-2.047 2.047h-26.603a2.046 2.046 0 0 1-2.046-2.047"
}))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__k)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9DBE9",
  d: "M193.447 256.995a8.184 8.184 0 0 1 8.185-8.185h14.325a8.185 8.185 0 0 1 8.185 8.185c0 1.13-.916 2.046-2.046 2.046h-26.603a2.046 2.046 0 0 1-2.046-2.046"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__l)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 85.137,
  height: 85.137,
  x: 67.216,
  y: 147.404,
  fill: "#BABEDE",
  rx: 42.569,
  transform: "rotate(6.892 67.216 147.404)"
}))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__m)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M141 188c-3.5 7-26.546-2.696-8-7s.334-24.885-7-21.5"
}))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__n)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M120.905 232.183c7.773 4.602 8.204 12.374 2.159 20.147"
}))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__o)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BABEDE",
  d: "M230.265 237.501a8.557 8.557 0 0 1-1.963 11.942l-12.167 8.731a8.557 8.557 0 0 1-11.942-1.963 2.14 2.14 0 0 1 .491-2.985l22.595-16.216a2.14 2.14 0 0 1 2.986.491"
}))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__p)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M233.9 254.148c33.776 12.644 31.323-17.51 14.073-5.787"
}))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__q)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M98.884 232.899c0 8.204 1.295 6.478 4.75 16.409"
}))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__r)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BABEDE",
  d: "M78.59 257.001a8.557 8.557 0 0 1 8.557-8.557h14.976a8.56 8.56 0 0 1 8.558 8.557 2.14 2.14 0 0 1-2.14 2.14H80.729a2.14 2.14 0 0 1-2.14-2.14"
}))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__s)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 144.222,
  cy: 251.898,
  r: 6.909,
  fill: "#BABEDE"
}))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__t)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 233.171,
  cy: 253.625,
  r: 6.909,
  fill: "#BABEDE"
}))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__u)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M102.77 155.177c-3.342-2.591 0-11.227 0-15.545"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 10.764,
  height: 15.657,
  x: 121.478,
  y: 113.248,
  fill: "#BABEDE",
  rx: 5.382,
  transform: "rotate(-2.123 121.478 113.248)"
})), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__v)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 54.801,
  height: 50.887,
  x: 73.117,
  y: 98.621,
  fill: "#BABEDE",
  rx: 25.443,
  transform: "rotate(-2.123 73.117 98.621)"
}))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#not-registered_svg__w)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10.764,
  height: 15.657,
  x: 69.698,
  y: 115.167,
  fill: "#BABEDE",
  rx: 5.382,
  transform: "rotate(-2.123 69.698 115.167)"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#223",
  d: "M84.134 124.162c-.2-5.4 4.016-9.941 9.416-10.141l21.515-.798c5.4-.2 9.941 4.016 10.141 9.417s-4.016 9.941-9.416 10.142l-21.515.797c-5.4.2-9.941-4.016-10.141-9.417"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#84848A",
  fillRule: "evenodd",
  d: "M89.053 124.557q-.002.143.003.287a4.893 4.893 0 1 0 9.76-.649l-2.004.075a2.896 2.896 0 0 1-2.76 3.283 2.893 2.893 0 0 1-2.994-3.07zM110.883 123.749q-.003.142.002.286a4.893 4.893 0 1 0 9.76-.648l-2.004.074q.02.14.025.286a2.894 2.894 0 1 1-5.779-.073z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__a",
  width: 5.181,
  height: 25.273,
  x: 188.243,
  y: 109.106,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__b",
  width: 7.454,
  height: 56.028,
  x: 174.127,
  y: 195.351,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__c",
  width: 72.075,
  height: 48.674,
  x: 154.137,
  y: 75,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: -4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__d",
  width: 39.746,
  height: 32.603,
  x: 144.676,
  y: 145.896,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__e",
  width: 13.642,
  height: 13.643,
  x: 136,
  y: 164,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__f",
  width: 62.714,
  height: 83.307,
  x: 159.073,
  y: 130.072,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 5,
  result: "effect1_innerShadow_172:781"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: -15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__g",
  width: 18.993,
  height: 48.365,
  x: 197.748,
  y: 203.876,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__h",
  width: 47.414,
  height: 24.011,
  x: 156.335,
  y: 144.191,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__i",
  width: 12.954,
  height: 13.817,
  x: 149,
  y: 155,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__j",
  width: 30.696,
  height: 10.232,
  x: 156.411,
  y: 248.941,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__k",
  width: 30.696,
  height: 10.232,
  x: 193.447,
  y: 248.81,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__l",
  width: 85.146,
  height: 85.146,
  x: 61.796,
  y: 152.2,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 5,
  result: "effect1_innerShadow_172:781"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 8,
  dy: -18
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__m",
  width: 21.216,
  height: 37.343,
  x: 122.859,
  y: 156.122,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__n",
  width: 12.307,
  height: 26.148,
  x: 117.905,
  y: 229.182,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__o",
  width: 28.079,
  height: 23.171,
  x: 203.792,
  y: 236.608,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__p",
  width: 32.42,
  height: 17.717,
  x: 230.899,
  y: 242.593,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__q",
  width: 10.751,
  height: 22.409,
  x: 95.884,
  y: 229.899,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__r",
  width: 32.091,
  height: 10.697,
  x: 78.59,
  y: 248.444,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__s",
  width: 13.817,
  height: 13.817,
  x: 137.313,
  y: 244.989,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__t",
  width: 13.817,
  height: 13.817,
  x: 226.263,
  y: 246.717,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__u",
  width: 7.485,
  height: 21.544,
  x: 98.285,
  y: 136.632,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__v",
  width: 54.799,
  height: 51.032,
  x: 74.042,
  y: 97.516,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 5,
  result: "effect1_innerShadow_172:781"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 11,
  dy: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})), /*#__PURE__*/React.createElement("filter", {
  id: "not-registered_svg__w",
  width: 10.946,
  height: 15.654,
  x: 69.894,
  y: 114.964,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: -2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_172:781"
})))));
export default SvgNotRegistered;